import React, { useContext } from 'react';
import { LoginHeader, Icon, Toast } from '@app/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OtpInput from 'react-otp-input';
import { useLocation } from '@app/utils';
import Button from '@app/components/button';
import {
  Container,
  InnerContainer,
  SuccessText,
  Text,
  EmailIcon,
  OtpText,
  Row,
  RowItem,
  ResendButton,
  ButtonContainer,
  Footer,
  SavingIndicator,
  ErrorMessage,
} from '@app/modules/email-verify/email-verify-components';
import { useForm } from 'react-hook-form';
import { primaryColor } from '@app/styles';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import {
  useResendEmailVerificationLinkMutation,
  useEmailVerificationMutation,
} from '@app/graphql';
import { AuthContext } from '@app/providers';
import { getDefaultUrl } from '@app/routes/routes-helper';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

const InputStyle = {
  width: '52px',
  height: '52px',
  border: '2px solid #D5DBDD',
  borderRadius: '4px',
};
export default function EmailVerify() {
  const { navigate } = useLocation();
  const [showToast, setShowToast] = React.useState(false);
  const [showErrorPage, SetShowErrorPage] = React.useState(false);
  const [
    resendEmailVerificationLink,
  ] = useResendEmailVerificationLinkMutation();
  const [emailVerify] = useEmailVerificationMutation();
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const defaultUrl: string = getDefaultUrl(userInfo);
  const { handleSubmit } = useForm();
  const [enablebutton, updateenablebutton] = React.useState(false);
  const [saving, updatesaving] = React.useState(false);
  const [resendbutton, updateresendbuttonbutton] = React.useState(true);
  const [message, updatemessage] = React.useState('');
  const [errormessage, updateerroemessage] = React.useState('');
  const [error, updateerror] = React.useState(false);
  const [otp, setotp] = React.useState('');
  const emailVerified =
    userInfo &&
    userInfo.emailVerification &&
    userInfo.emailVerification.completed;

  React.useEffect(() => {
    if (emailVerified) {
      navigate(defaultUrl);
    }
    // eslint-disable-next-line
  }, [emailVerified, navigate]);

  function onChange(data: any) {
    setotp(data);
    updateenablebutton(data.length === 4);
  }
  function onSubmit() {
    updateenablebutton(false);
    updateresendbuttonbutton(false);
    updatesaving(true);
    updateerror(false);
    if (userInfo && userInfo.firebaseId) {
      emailVerify({
        variables: {
          firebaseId: userInfo.firebaseId,
          verificationCode: otp,
        },
      })
        .then((res: any) => {
          if (res.data.verifyUserEmail.success) {
            updatesaving(false);
            updateerror(false);
            updateresendbuttonbutton(true);
            updatemessage('Your email is verified!');
            setShowToast(true);
            setTimeout(() => {
              setShowToast(false);
              setUserInfo({
                ...userInfo,
                emailVerification: {
                  completed: true,
                },
              });
              navigate(defaultUrl);
            }, 1000);
          } else {
            updatesaving(false);
            updateresendbuttonbutton(true);
            updateerroemessage(res.data.verifyUserEmail.message);
            updateerror(true);
          }
        })
        .catch((err: any) => {
          SetShowErrorPage(true);
          updatesaving(false);
          updateresendbuttonbutton(true);
        });
    }
  }
  function resendLink() {
    if (!userInfo) {
      return false;
    }
    updatesaving(true);
    updateerror(false);
    updateresendbuttonbutton(false);
    resendEmailVerificationLink({
      variables: {
        firebaseId: userInfo.firebaseId,
      },
    })
      .then((res: any) => {
        if (res.data.resendEmailVerificationCode.success) {
          updatesaving(false);
          updateerror(false);
          updatemessage('4 digit pin has been sent to ' + userInfo.email);
          setShowToast(true);
          setShowToast(false);
          setTimeout(() => {
            updateresendbuttonbutton(true);
          }, 10000);
        }
      })
      .catch((err: any) => {
        SetShowErrorPage(true);
      });
  }
  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <>
          <LoginHeader location="email-verify" />
          <Container>
            <Toast
              message={message}
              showToast={showToast}
              onClose={() => setShowToast(false)}
            />
            <InnerContainer>
              <EmailIcon>
                <Icon name="emailSuccess" />
              </EmailIcon>
              <SuccessText>Thank you for joining!</SuccessText>
              <Text>
                Before beginning your transactions, please verify your email
                address.
              </Text>
              <OtpText>
                Enter the 4-digit confirmation code we have sent to <br />
                {userInfo.email}.
              </OtpText>
              <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <Row>
                  <OtpInput
                    isInputNum
                    onChange={onChange}
                    value={otp}
                    inputStyle={InputStyle}
                    numInputs={4}
                    separator={<RowItem />}
                  />
                </Row>
                <Footer>
                  {saving && (
                    <SavingIndicator>
                      <FontAwesomeIcon
                        color={primaryColor}
                        icon={faCircleNotch}
                        size="lg"
                        spin
                      />
                    </SavingIndicator>
                  )}
                  <ResendButton enabled={!resendbutton}>
                    <Button
                      variant="text"
                      size="large"
                      width="100%"
                      onClick={resendLink}>
                      Resend Code
                    </Button>
                  </ResendButton>
                  <ButtonContainer disabled={!enablebutton}>
                    <Button
                      variant="text"
                      size="large"
                      width="100%"
                      type="submit">
                      Submit
                    </Button>
                  </ButtonContainer>
                </Footer>
                {error && <ErrorMessage>{errormessage}</ErrorMessage>}
              </form>
            </InnerContainer>
          </Container>
        </>
      )}
    </>
  );
}
